import { base64ToArray, cryptoKeyToArray, cryptoPairsFromArray, encryptWithAes, } from '@lucidlink/ts-crypto/crypto';
import { prepareMemberCrypto } from '#sdk/common/member';
export const prepareAcceptIndividualInvitationWithMemberCrypto = async (params) => {
    const invitationPublicKeyArr = base64ToArray(params.acceptableInvitationData.publicKey);
    const memberCrypto = await prepareMemberCrypto({
        workspaceId: params.acceptableInvitationData.workspace.id,
        invitationKeys: await cryptoPairsFromArray(invitationPublicKeyArr, params.invitationPrivateKeyArray),
    }, params.member.id);
    const ePrivateKeyByUserKey = await encryptWithAes(await cryptoKeyToArray(memberCrypto.memberKeys.encryptPair.privateKey), params.userKey);
    return {
        invitationId: params.acceptableInvitationData.id,
        ePrivateKeyByUserKey,
        memberCrypto: memberCrypto.storedCrypto,
    };
};
